module.exports = __webpack_public_path__ + "static/media/strongher10_preview.bc68b4a0.jpg";